import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}

const tId = t.union([t.undefined, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);

const DiffAtributeCodec = t.type({
  From: t.union([t.undefined, t.string, t.number, t.boolean]),
  To: t.union([t.undefined, t.string, t.number, t.boolean]),
  Path: t.string,
  type: t.string,
});

const DataAttributeCodec = t.type({
  From: t.any,
  To: t.any,
  Diff: t.any,
});

const ChangeByAttributeCodec = t.type({
  id: t.string,
  Name: t.string,
});

const AttributeCodec = t.type({
  EntityName: t.string,
  ChangeType: t.string,
  Data: DataAttributeCodec,
  ChangedBy: ChangeByAttributeCodec,
  EntityIdentifier: t.any
});

const DataCodec = t.type({
  id: tId,
  type: t.string,
  attributes: AttributeCodec,
  createdAt: t.string,
  updatedAt: t.string,
  dataDetail: t.any,
});

const Pagination = t.type({
  limit: t.number,
  offset: t.number,
  total: t.number,
});

export type Data = t.TypeOf<typeof DataCodec>;
export type Error = t.TypeOf<typeof ErrorCodec>;

export type DiffItem = t.TypeOf<typeof DiffAtributeCodec>;
export const AuditCodec = t.type(
  {
    errors: tOptional(t.array(ErrorCodec)),
    data: tOptional(t.array(DataCodec)),
    pagination: tOptional(Pagination),
  },
  "AuditCodec"
);

export type Audit = t.TypeOf<typeof AuditCodec>;

export enum AuditActionTypes {
  FETCH = "@@audit/FETCH",
  FETCH_SUCCESS = "@@audit/FETCH_SUCCESS",
  FETCH_ERROR = "@@audit/FETCH_ERROR",
}

export interface AuditState {
  readonly loading: boolean;
  readonly data: Audit | undefined;
  readonly errors?: string;
}
